export enum RiskTypes {
  FLOOD = 'Gefahr_Hochwasser',
  SEA_WATER = 'Gefahr_Seewasser',
  EARTHQUAKE = 'Gefahr_Erdbeben',
  TSUNAMIS = 'Gefahr_Tsunamis',
  CYCLONES = 'Gefahr_Zyklone',
  HAIL = 'Gefahr_Hagel',
  WINTER_STORM = 'Gefahr_Wintersturm',
  NATIONAL_POLITICS_DANGER = 'Gefahr_Politik',
  LOCAL_POLITICS_DANGER = 'Gefahr_Politik_S'
}
